import { NGSLibraryQCService } from './ngs-library-qc/ngs-library-qc-service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { BlockUIModule } from 'primeng/blockui';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FieldsetModule } from 'primeng/fieldset';
import { GrowlModule } from 'primeng/growl';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule, FileUploadModule, CalendarModule, MessageModule, OverlayPanelModule, SplitButtonModule, ColorPickerModule, ConfirmationService, ConfirmDialogModule, SelectButtonModule, ToggleButtonModule, GalleriaModule } from 'primeng/primeng';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { TreeTableModule } from 'primeng/treetable';
import { TreeModule } from 'primeng/primeng';
import { TabViewModule } from 'primeng/tabview';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { AppComponent } from './app.component';
import { CarrierComponent } from './carrier/carrier.component';
import { CarrierService } from './carrier/carrier.service';
import { Globals } from './globals';
import { MessagesComponent } from './messages/messages.component';
import { MessagesService } from './messages/messages.service';
import { HamiltonLRSFileNameFormatPipe } from './pipes/hamilton-lrs-file-name-format.pipe';
import { QcSampleService } from './qc-sample/qc-sample-service';
import { QcSampleComponent } from './qc-sample/qc-sample.component';
import { TicketComponent } from './ticket/ticket.component';
import { TicketService } from './ticket/ticket.service';
import { CarrierSearchComponent } from './carrier-search/carrier-search.component';
import { CarrierSearchService } from './carrier-search/carrier-search.service';
import { CarrierGridComponent } from './carrier-grid/carrier-grid.component';
import { CarrierGridService } from './carrier-grid/carrier-grid.service';
import { TubeSearchComponent } from './tube-search/tube-search.component';
import { TubeSearchService } from './tube-search/tube-search.service';
import { TubeSearchFilterPipe } from './pipes/tube-searchFilterPipe';
import { CarrierStatusComponent } from './carrier-status/carrier-status.component';
import { BarcodeScanComponent } from './barcode-scan/barcode-scan.component';
import { BarcodeScanService } from './barcode-scan/barcode-scan.service';
import { DataViewModule } from 'primeng/dataview';
import { CarrierStatusService } from './carrier-status/carrier-status.service';
import { ChartModule } from 'primeng/chart';
import { MasterdataComponent } from './masterdata/masterdata.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './common-services/auth.guard';
import { AuthenticationService } from './common-services/authentication.service';
import { AzureAppInsightsService } from './common-services/appinsights.azure.service';
import { MasterDataService } from './masterdata/masterdata.service';
import { CrudTableComponent } from './crud-table/crud-table.component';
import { CheckboxModule } from 'primeng/checkbox';
import { SwabSampleComponent } from './swab-sample/swab-sample.component';
import { SwabSampleService } from './swab-sample/swab-sample.service';
import { SwabSampleReceptionComponent } from './swab-sample-reception/swab-sample-reception.component';
import { OrderListComponent } from './order-list/order-list.component';
import { OrderListService } from './order-list/order-list.service';
import { OrderListModule } from 'primeng/orderlist';
import { ContainerMergeComponent } from './container-merge/container-merge.component';
import { ContainerMergeService } from './container-merge/container-merge.service';
import { SearchOrderComponent } from './search-order/search-order.component';
import { SearchOrderService } from './search-order/search-order.service';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { ContainerViewComponent } from './container-view/container-view.component';
import { QuadrantViewComponent } from './quadrant-view/quadrant-view.component';
import { ContainerCellViewComponent } from './container-cell-view/container-cell-view.component';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressTrackerComponent } from './progress-tracker/progress-tracker.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { StepSequenceComponent } from './step-sequence/step-sequence.component';
import { ReactionMixComponent } from './step-reaction-mix/reaction-mix.component';
import { StepSequenceService } from './step-sequence/step-sequence.service';
import { StepSplitContainersComponent } from './step-split-containers/step-split-containers.component';
import { StepDtRemovalComponent } from './step-dt-removal/step-dt-removal.component';
import { StepDtRemovalService } from './step-dt-removal/step-dt-removal.service';
import { StepThermalCyclingComponent } from './step-thermal-cycling/step-thermal-cycling.component';
import { LabComponent } from './lab/lab.component';
import { HeaderComponent } from './header/header.component';
import { LabGuard } from './common-services/lab.guard';
import { LabEmitterService } from './common-services/lab-emitter.service';
import { ContainerSplitService } from './step-split-containers/step-split-containers.service';
import { NgsVolumeAdjustmentComponent } from './ngs-volume-adjustment/ngs-volume-adjustment.component';
import { NgsVolumeAdjustmentService } from './ngs-volume-adjustment/ngs-volume-adjustment.service';
import { FileHelpersModule } from 'ngx-file-helpers';
import { ReactionSetComponent } from './reaction-set/reaction-set.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { PrintPlateLabelService } from './print-plate-labels/print-plate-labels-service';
import { PrintPlateLabelsComponent } from './print-plate-labels/print-plate-labels.component';
import { SpinnerModule } from 'primeng/spinner';
import { ReactionSetService } from './reaction-set/reaction-set.service';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { MultiSelectModule } from 'primeng/multiselect';
import { ClientNamePipe } from './pipes/client-name.pipe';
import { PendingPlatesComponent } from './pending-plates/pending-plates.component';
import { ListboxModule } from 'primeng/listbox';
import { PendingPlatesService } from './pending-plates/pending-plates.service';
import { PanelModule } from 'primeng/panel';
import { EntryQcComponent } from './entry-qc/entry-qc.component';
import { PremixedQuadrantViewComponent } from './premixed-quadrant-view/premixed-quadrant-view.component';
import { NgsFragmentAnalysisComponent } from './ngs-fragment-analysis/ngs-fragment-analysis.component';
import { NgsFragmentAnalysisService } from './ngs-fragment-analysis/ngs-fragment-analysis.service';

import { QualityreportListComponent } from './qualityreport-list/qualityreport-list.component';
import { CardModule } from 'primeng/card';
import { QualityreportListService } from './qualityreport-list/qualityreport-list.service';
import { WorkListComponent } from './ngs-work-list/work-list.component';
import { StepPlatePreparationComponent } from './step-plate-preparation/step-plate-preparation.component';

import { WorkListService } from './ngs-work-list/work-list.service';
import { StepRedoComponent } from './step-redo/step-redo.component';
import { StepRedoService } from './step-redo/step-redo.service';
import { StandardPrimerComponent } from './standard-primer/standard-primer.component';
import { BarcodeTemplateComponent } from './barcode-template/barcode-template.component';
import { MdmProcessStepComponent } from './mdm-process-step/mdm-process-step.component';
import { MdmProcessStepService } from './mdm-process-step/mdm-process-step.service';
import { QcreportDetailComponent } from './qcreport-detail/qcreport-detail.component';
import { QcreportDetailService } from './qcreport-detail/qcreport-detail.service';
import { FilterViewComponent } from './filter-view/filter-view.component';
import { NGSLibraryQCComponent } from './ngs-library-qc/ngs-library-qc.component';
import { TubeRackComponent } from './tube-rack/tube-rack.component';
import { PickListModule } from 'primeng/picklist';

import { DatePipe } from '@angular/common';
import { AgptestingNewviewComponent } from './agptesting-newview/agptesting-newview.component';
import { APGTestingService } from './agptesting-newview/apgtesting.service';
import { AppService } from './app.service';
import { ApgtestingUnboxingComponent } from './apgtesting-unboxing/apgtesting-unboxing.component';
import { SendersTemplateComponent } from './senders-template/senders-template.component';
import { UnboxingDirtyCheckGuard } from './apgtesting-unboxing/unboxing-dirty-check-guard';
import { ApgPrintLabelsComponent } from './apg-print-labels/apg-print-labels.component';
import { APGPrintService } from './apg-print-labels/apg-print-service';

import { AzureAuthGuard } from './common-services/auth.azure.guard';
import { AccessTokenGuard } from './common-services/access.token.guard';
import { AccessTokenInterceptor } from './common-services/access.token.interceptor';
import { KitsTemplateComponent } from './kits-template/kits-template.component';
import { ApgNcSampleService } from './apg-nc-sample/apg-nc-sample.service';
import { MdmGuard } from './common-services/mdm.guard';
import { JwtInterceptor } from './common-services/jwt.interceptor';
import { NewViewDirtyCheckGuard } from './agptesting-newview/newview-dirty-check-guard';
import { ApgDeliveryComponent } from './apg-delivery/apg-delivery.component';
import { ApgDeliveryService } from './apg-delivery/apg-delivery.service';
import { BUGuard } from './common-services/bu.guard';
import { environment } from "../environments/environment";
import { RefreshAuthenticationService } from './common-services/access-token-refresh';
import { ApgAdministrationComponent } from './apg-administration/apg-administration.component';
import { ApgParentageComponent } from './apg-parentage/apg-parentage.component';
import { APGAdministrationService } from './apg-administration/apg-administration.service';
import { ProblemCategoryTemplateComponent } from './mdm-problem-category-template/problem-category-template.component';
import { ProblemCategoryService } from './mdm-problem-category-template/problem-category-service';
import { ProblemComponent } from './mdm-nc-problem/problem.component';
import { ProblemService } from './mdm-nc-problem/problem-service';
import { ApgDeliverBoxManagerComponent } from './apg-deliver-box-manager/apg-deliver-box-manager.component';
import { MdmResultProcessComponent } from './mdm-result-process/mdm-result-process.component';
import { ResultProcessService } from './mdm-result-process/mdm-result-service';
import { ResultEngineConfigComponent } from './mdm-result-engine-config/result-engine-config.component';
import { ApgSampleResultViewComponent } from './apg-sample-result-view/apg-sample-result-view.component';
import { UnprepairedMaterialComponent } from './unprepaired-material/unprepaired-material.component';
import { ExteralSenderLoginTemplateComponent } from './mdm-exteral-sender-login-template/exteral-sender-login-template.component';
import { ManufacturerConfigComponent } from './mdm-manufacturer-config/manufacturer-config.component';
import { RedoReasonsComponent } from './redo-reasons/redo-reasons.component';
import { InboundFileProcessingComponent } from './inbound-file-processing/inbound-file-processing.component';
import { WorkFlowComponent } from './work-flow/work-flow.component';
import { MdmControlsComponent } from './mdm-controls/mdm-controls.component';
import { BatchStatusComponent } from './batch-status/batch-status.component';
import { ParentageAnalysisComponent } from './parentage-analysis/parentage-analysis.component';
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LabComponent,
    TicketComponent,
    CarrierComponent,
    MessagesComponent,
    HamiltonLRSFileNameFormatPipe,
    QcSampleComponent,
    CarrierSearchComponent,
    CarrierGridComponent,
    TubeSearchComponent,
    TubeSearchFilterPipe,
    CarrierStatusComponent,
    BarcodeScanComponent,
    MasterdataComponent,
    LoginComponent,
    CrudTableComponent,
    SwabSampleComponent,
    SwabSampleReceptionComponent,
    OrderListComponent,
    ContainerMergeComponent,
    SearchOrderComponent,
    OrderDetailsComponent,
    ContainerViewComponent,
    QuadrantViewComponent,
    ContainerCellViewComponent,
    ProgressTrackerComponent,
    StepSequenceComponent,
    ReactionMixComponent,
    StepSplitContainersComponent,
    StepDtRemovalComponent,
    StepThermalCyclingComponent,
    NgsVolumeAdjustmentComponent,
    NgsFragmentAnalysisComponent,
    ReactionSetComponent,
    PrintPlateLabelsComponent,
    ClientNamePipe,
    PendingPlatesComponent,
    EntryQcComponent,
    PremixedQuadrantViewComponent,
    QualityreportListComponent,
    StepPlatePreparationComponent,
    WorkListComponent,
    StepRedoComponent,
    StandardPrimerComponent,
    BarcodeTemplateComponent,
    MdmProcessStepComponent,
    QcreportDetailComponent,
    FilterViewComponent,
    NGSLibraryQCComponent,
    TubeRackComponent,
    AgptestingNewviewComponent,
    ApgtestingUnboxingComponent,
    SendersTemplateComponent,
    ApgPrintLabelsComponent,
    KitsTemplateComponent,
    ApgDeliveryComponent,
    ApgAdministrationComponent,
    ProblemCategoryTemplateComponent,
    ProblemComponent,
    ApgDeliverBoxManagerComponent,
    MdmResultProcessComponent,
    ResultEngineConfigComponent,
    ApgSampleResultViewComponent,
    UnprepairedMaterialComponent,
    ExteralSenderLoginTemplateComponent,
    ManufacturerConfigComponent,
    RedoReasonsComponent,
    InboundFileProcessingComponent,
    WorkFlowComponent,
    MdmControlsComponent,
    BatchStatusComponent,
    ParentageAnalysisComponent,
    ApgParentageComponent
  ],
  imports: [
    BrowserModule,
    TableModule,
    TreeModule,
    TreeTableModule,
    TabViewModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TieredMenuModule,
    ButtonModule,
    InputSwitchModule,
    GrowlModule,
    DialogModule,
    FormsModule,
    BlockUIModule,
    ProgressSpinnerModule,
    DropdownModule,
    FileUploadModule,
    FieldsetModule,
    InputTextModule,
    ListboxModule,
    AutoCompleteModule,
    CalendarModule,
    DataViewModule,
    ReactiveFormsModule,
    MessageModule,
    ChartModule,
    CheckboxModule,
    OverlayPanelModule,
    OrderListModule,
    TooltipModule,
    NgxChartsModule,
    SplitButtonModule,
    FileHelpersModule,
    RadioButtonModule,
    SpinnerModule,
    ScrollPanelModule,
    PanelModule,
    MultiSelectModule,
    CardModule,
    ColorPickerModule,
    ConfirmDialogModule,
    SelectButtonModule,
    ToggleButtonModule,
    GalleriaModule,
    PickListModule,
    RouterModule.forRoot([
      { path: '', component: HeaderComponent, canActivate: [AzureAuthGuard, LabGuard] },
      { path: 'carriers', component: CarrierComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], data: { claim: [environment.AZURE_Sanger_Cologne_CLAIM, environment.AZURE_Sanger_Ebersberg_CLAIM] } },
      { path: 'trackCarriers', component: CarrierSearchComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], data: { claim: [environment.AZURE_Sanger_Cologne_CLAIM, environment.AZURE_Sanger_Ebersberg_CLAIM] } },
      { path: 'carrierstatus', component: CarrierStatusComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], data: { claim: [environment.AZURE_Sanger_Cologne_CLAIM, environment.AZURE_Sanger_Ebersberg_CLAIM] } },
      { path: 'scanBarcode', component: BarcodeScanComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], data: { claim: [environment.AZURE_Sanger_Cologne_CLAIM, environment.AZURE_Sanger_Ebersberg_CLAIM] } },
      { path: 'lab', component: LabComponent, canActivate: [AccessTokenGuard] },
      { path: 'login', component: LoginComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], data: { claim: [environment.AZURE_Sanger_Cologne_CLAIM, environment.AZURE_Sanger_Ebersberg_CLAIM] } },
      { path: 'admin/masterdata', component: MasterdataComponent, canActivate: [AzureAuthGuard, LabGuard, MdmGuard, AuthGuard], data: { claim: [environment.AZURE_Sanger_Cologne_CLAIM, environment.AZURE_Sanger_Ebersberg_CLAIM] } },
      { path: 'orders', component: OrderListComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], data: { claim: [environment.AZURE_Sanger_Cologne_CLAIM, environment.AZURE_Sanger_Ebersberg_CLAIM] } },
      { path: 'reactionSet', component: ReactionSetComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], data: { claim: [environment.AZURE_Sanger_Cologne_CLAIM, environment.AZURE_Sanger_Ebersberg_CLAIM] } },
      { path: 'qcReports', component: QualityreportListComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], data: { claim: [environment.AZURE_Sanger_Cologne_CLAIM, environment.AZURE_Sanger_Ebersberg_CLAIM] } },
      { path: 'qcReportDetail', component: QcreportDetailComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], data: { claim: [environment.AZURE_Sanger_Cologne_CLAIM, environment.AZURE_Sanger_Ebersberg_CLAIM] } },
      { path: 'logout', component: LoginComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], data: { claim: [environment.AZURE_Sanger_Cologne_CLAIM, environment.AZURE_Sanger_Ebersberg_CLAIM] } },

      { path: 'swabSample', component: SwabSampleComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], data: { claim: [environment.AZURE_GenoTyping_Aarhus_GROUP_CLAIM] } },
      { path: 'swabSampleReception', component: SwabSampleReceptionComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], data: { claim: [environment.AZURE_GenoTyping_Aarhus_GROUP_CLAIM] } },

      { path: 'entryQC', component: EntryQcComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], data: { claim: [environment.AZURE_NGS_Konstanz_GROUP_CLAIM] } },
      { path: 'worklist', component: WorkListComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], data: { claim: [environment.AZURE_NGS_Konstanz_GROUP_CLAIM] } },

      { path: 'covid19entryNew', component: AgptestingNewviewComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], canDeactivate: [NewViewDirtyCheckGuard], data: { claim: [environment.AZURE_APG_Ebersberg_GROUP_CLAIM, environment.AZURE_APG_Training_GROUP_CLAIM, environment.AZURE_APG_Denmark_GROUP_CLAIM, environment.AZURE_APG_NETHERLANDS_GROUP_CLAIM,environment.AZURE_APG_CPH_PCR_GROUP_CLAIM, environment.AZURE_APG_COLOGNE_GROUP_CLAIM, environment.AZURE_APG_SWEDEN_GROUP_CLAIM,environment.AZURE_APG_TEDDINGTON_GROUP_CLAIM,environment.AZURE_APG_ANIMAL_GROUP_CLAIM] } },
      { path: 'covid19unboxing', component: ApgtestingUnboxingComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], canDeactivate: [UnboxingDirtyCheckGuard], data: { claim: [environment.AZURE_APG_Ebersberg_GROUP_CLAIM, environment.AZURE_APG_Training_GROUP_CLAIM,  environment.AZURE_APG_Denmark_GROUP_CLAIM, environment.AZURE_APG_NETHERLANDS_GROUP_CLAIM,environment.AZURE_APG_CPH_PCR_GROUP_CLAIM, environment.AZURE_APG_COLOGNE_GROUP_CLAIM, environment.AZURE_APG_SWEDEN_GROUP_CLAIM,environment.AZURE_APG_TEDDINGTON_GROUP_CLAIM,environment.AZURE_APG_ANIMAL_GROUP_CLAIM] } },
      { path: 'apg-delivery', component: ApgDeliveryComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], data: { claim: [environment.AZURE_APG_Ebersberg_GROUP_CLAIM, environment.AZURE_APG_Training_GROUP_CLAIM, environment.AZURE_APG_Denmark_GROUP_CLAIM, environment.AZURE_APG_NETHERLANDS_GROUP_CLAIM, environment.AZURE_APG_CPH_PCR_GROUP_CLAIM,environment.AZURE_APG_COLOGNE_GROUP_CLAIM, environment.AZURE_APG_SWEDEN_GROUP_CLAIM,environment.AZURE_APG_TEDDINGTON_GROUP_CLAIM,environment.AZURE_APG_ANIMAL_GROUP_CLAIM] } },
      { path: 'apg-adminstration', component: ApgAdministrationComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], data: { claim: [environment.AZURE_APG_Ebersberg_GROUP_CLAIM, environment.AZURE_APG_Training_GROUP_CLAIM, environment.AZURE_APG_Denmark_GROUP_CLAIM, environment.AZURE_APG_NETHERLANDS_GROUP_CLAIM, environment.AZURE_APG_CPH_PCR_GROUP_CLAIM,environment.AZURE_APG_COLOGNE_GROUP_CLAIM, environment.AZURE_APG_SWEDEN_GROUP_CLAIM,environment.AZURE_APG_TEDDINGTON_GROUP_CLAIM,environment.AZURE_APG_ANIMAL_GROUP_CLAIM] } },
      { path: 'apg-delivery-box-manager', component: ApgDeliverBoxManagerComponent, canActivate: [AzureAuthGuard, LabGuard, BUGuard], data: { claim: [environment.AZURE_APG_Ebersberg_GROUP_CLAIM, environment.AZURE_APG_Training_GROUP_CLAIM, environment.AZURE_APG_Denmark_GROUP_CLAIM, environment.AZURE_APG_NETHERLANDS_GROUP_CLAIM, environment.AZURE_APG_CPH_PCR_GROUP_CLAIM,environment.AZURE_APG_COLOGNE_GROUP_CLAIM, environment.AZURE_APG_SWEDEN_GROUP_CLAIM,environment.AZURE_APG_TEDDINGTON_GROUP_CLAIM,environment.AZURE_APG_ANIMAL_GROUP_CLAIM] } },
      { path: 'apg-parentage', component:ApgParentageComponent, canActivate:[AzureAuthGuard, LabGuard, BUGuard], data:{claim:[environment.AZURE_APG_Ebersberg_GROUP_CLAIM, environment.AZURE_APG_Training_GROUP_CLAIM, environment.AZURE_APG_Ebersberg_GROUP_CLAIM, environment.AZURE_APG_NETHERLANDS_GROUP_CLAIM, environment.AZURE_APG_CPH_PCR_GROUP_CLAIM,environment.AZURE_APG_COLOGNE_GROUP_CLAIM, environment.AZURE_APG_SWEDEN_GROUP_CLAIM,environment.AZURE_APG_TEDDINGTON_GROUP_CLAIM,environment.AZURE_APG_ANIMAL_GROUP_CLAIM]}}
    ]),
  ],
  providers: [
    LabGuard,
    LabEmitterService,
    CarrierService,
    Globals,
    MessagesService,
    QcSampleService,
    TicketService,
    CarrierSearchService,
    CarrierGridService,
    TubeSearchService,
    BarcodeScanService,
    MasterDataService,
    CarrierStatusService,
    { provide: HTTP_INTERCEPTORS, useClass: AccessTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    AuthGuard,
    AzureAuthGuard,
    MdmGuard,
    AccessTokenGuard,
    BUGuard,
    AuthenticationService,
    SwabSampleService,
    ContainerMergeService,
    OrderListService,
    SearchOrderService,
    StepSequenceService,
    StepDtRemovalService,
    ContainerSplitService,
    NgsVolumeAdjustmentService,
    PrintPlateLabelService,
    ReactionSetService,
    PendingPlatesService,
    NgsFragmentAnalysisService,
    QualityreportListService,
    WorkListService,
    StepRedoService,
    ConfirmationService,
    MdmProcessStepService,
    QcreportDetailService,
    NGSLibraryQCService,
    DatePipe,
    APGTestingService,
    AppService,
    UnboxingDirtyCheckGuard,
    NewViewDirtyCheckGuard,
    APGPrintService,
    ApgNcSampleService,
    AzureAppInsightsService,
    ApgDeliveryService,
    RefreshAuthenticationService,
    APGAdministrationService,
    ProblemCategoryService,
    ProblemService,
    ResultProcessService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
